import React from 'react';
import CrudPage from '../../components/CrudPage';
import { favoriteApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'favoriteId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Property ID', field: 'propertyId' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'propertyId', label: 'Property ID', type: 'number', required: true },
];

const FavoritePage = () => (
  <CrudPage
    title="Favorites"
    subtitle="Manage investor favorites"
    api={favoriteApi}
    columns={columns}
    formFields={formFields}
    idField="favoriteId"
  />
);

export default FavoritePage;
